// import { useDeleteUser, useGetAllUsers } from "./useOrgUsers";
import { createColumnHelper } from "@tanstack/react-table";
import { useLocation, useNavigate } from "react-router-dom";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
import {
  useProjectByUserId,
  useChatByUserId,
  useResearchByUserId,
  useUsersPage,
  usePatchEditUserStatus,
  useDeleteUser,
} from "../../api/api-hooks";
import { useEffect, useMemo, useState } from "react";
import { useAdminData } from "../../lib/useAdminData";
import useCommonStore from "../../store/CommonStore";
import {
  filterDataByDate,
  getDateRangeFromSelectedValue,
} from "../../common/Constants";
import { Button, DialogTrigger, Popover } from "react-aria-components";
import ConfirmationPopup from "../../common/ConfirmationPopup";
import { usePagination } from "../hooks/usePagination";
export type UserActionType = "Activate" | "Deactivate" | "Delete";

function prepareColumns(
  columnHelper: any,
  handleFetch: any,
  handleActions: any,
  showOuterPopup: boolean,
  setShowOuterPopup: React.Dispatch<React.SetStateAction<boolean>>,
  showConfirmDelete: boolean,
  setShowConfirmDelete: React.Dispatch<React.SetStateAction<boolean>>,
  filteredData: any,
  navigate: any
) {
  return [
    columnHelper.accessor((row: any) => `${row.username} ${row.user_email}`, {
      id: "userName",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;
        const fetchId = row?.original?.user_id;

        // const roles = original.user_role.map((role: any) => {
        //   return role;
        // });

        return (
          <div className=" flex flex-col gap-1 underline cursor-pointer">
            <div
              onClick={() => navigate(`/user/${fetchId}`)}
              className="font-normal text-gray-900 text-sm leading-5
"
            >
              {original?.username || "--"}
            </div>
            {/* <div className=" w-32  text-sm text-gray-600  ">
              {original?.user_email || "--"}
            </div> */}

            <div
              className="  md:hidden text-sm text-gray-600  "
              onClick={() => handleFetch("chat", original?.user_id)}
            >
              User Chats: {original?.user_chats || "--"}
            </div>
            <div
              className="  md:hidden text-sm text-gray-600  "
              onClick={() => handleFetch("project", original?.user_id)}
            >
              User Projects: {original?.user_projects || "--"}
            </div>
            {/* <div
              className="  md:hidden text-sm text-gray-600 leading-5
"
            >
              Roles: {roles.join(" , ") || "--"}
            </div> */}
          </div>
        );
      },
      header: () => <div>{`Name (${filteredData.length})`}</div>,
      enableColumnFilter: true,
    }),

    columnHelper.accessor((row: any) => `${row.username} ${row.user_email}`, {
      id: "user_email",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div
              className=" font-normal text-gray-900 text-sm leading-5
"
            >
              {original?.user_email || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Email</div>,
      enableColumnFilter: true,
    }),

    // columnHelper.accessor((row: any) => row.user_chats, {
    //   id: "user_chats",
    //   cell: (info: any) => {
    //     const row = info.row;
    //     const original = row?.original;

    //     return (
    //       <div className="hidden md:block leading-10">
    //         {original?.user_chats ? (
    //           <Link
    //             to={`/chat/${original.user_id}`} // Navigate to chat page
    //             className="font-semibold text-blue-600 text-base underline"
    //           >
    //             {original?.user_chats}
    //           </Link>
    //         ) : (
    //           "--"
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">Chats</div>,
    //   enableColumnFilter: true,
    // }),

    // columnHelper.accessor((row: any) => row.user_projects, {
    //   id: "user_projects",
    //   cell: (info: any) => {
    //     const row = info.row;
    //     const original = row?.original;

    //     return (
    //       <div className="hidden md:block leading-10">
    //         {original?.user_projects ? (
    //           <Link
    //             to={`/projects/${original.user_id}`}
    //             className="font-semibold text-blue-600 text-base underline"
    //           >
    //             {original?.user_projects}
    //           </Link>
    //         ) : (
    //           "--"
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">Projects</div>,
    //   enableColumnFilter: true,
    // }),

    // columnHelper.accessor((row: any) => row.user_research, {
    //   id: "user_research",
    //   cell: (info: any) => {
    //     const row = info.row;
    //     const original = row?.original;

    //     return (
    //       <div className="hidden md:block leading-10">
    //         {original?.user_research ? (
    //           <Link
    //             to={`/research/${original.user_id}`} // Navigate to research page
    //             className="font-semibold text-blue-600 text-base underline"
    //           >
    //             {original?.user_research}
    //           </Link>
    //         ) : (
    //           "--"
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">Research</div>,
    //   enableColumnFilter: true,
    // }),

    columnHelper.accessor((row: any) => row.country, {
      id: "country",
      cell: (info: any) => {
        const original = info?.row?.original;
        return (
          <div className="flex flex-col gap-1">
            <div className="font-normal text-gray-900 text-sm leading-5">
              {/* {Array.isArray(original?.country) &&
              original.country.length > 1 ? (
                original.country[1]
              ) : typeof original?.country === "string" ? (
                original.country
              ) : (
                <div className="flex justify-center items-center min-h-[1.5rem] w-full">
                  --
                </div>
              )} */}
              {original.country ? original.country : ""}
            </div>
          </div>
        );
      },
      header: () => <div>Location</div>,
    }),

    // columnHelper.accessor((row: any) => row.country, {
    //   id: "country",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;

    //     return (
    //       <div className="flex flex-col gap-1">
    //         <div className="font-normal text-gray-900 text-sm leading-5">
    //           {/* {Array.isArray(original?.country) &&
    //           original.country.length > 1 ? (
    //             original.country[1]
    //           ) : typeof original?.country === "string" ? (
    //             original.country
    //           ) : (
    //             <div className="flex justify-center items-center min-h-[1.5rem] w-full">
    //               --
    //             </div>
    //           )} */}
    //           {original.country || "--"}
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <div>Session Duration</div>,
    // }),

    columnHelper.accessor((row: any) => row.prompt, {
      id: "prompt",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className="hidden md:block leading-10">
            {original?.total_prompt ? (
              //   <Link
              //     to={`/research/${original.user_id}`} // Navigate to research page
              //     className="font-semibold text-blue-600 text-base underline"
              //   >
              //     {original?.user_research}
              //   </Link>
              <div className="font-normal text-gray-900 text-sm leading-5">
                {original?.total_prompt}
              </div>
            ) : (
              0
            )}
          </div>
        );
      },
      header: () => <div className="hidden md:block">Total Prompts</div>,
      enableColumnFilter: true,
    }),

    //     columnHelper.accessor((row: any) => row.user_role.join(", "), {
    //       id: "user_role",
    //       cell: (info: any) => {
    //         const row = info.row;
    //         const original = row?.original;

    //         const roles = original.user_role.map(
    //           (role: any) =>
    //             role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
    //         );

    //         return (
    //           <div className=" hidden md:block leading-10">
    //             <div
    //               className="font-normal text-gray-900 text-sm leading-5
    // "
    //             >
    //               {roles.join(" , ") || "--"}
    //             </div>
    //           </div>
    //         );
    //       },
    //       header: () => <div className="hidden md:block">Roles</div>,
    //       enableColumnFilter: true,
    //     }),

    // columnHelper.accessor((row: any) => row.user_role, {
    //   id: "user_session",
    //   cell: (info: any) => {
    //     // const row = info.row;

    //     return (
    //       <div className=" hidden md:block leading-10">
    //         <div className=" leading-5 mt-1  text-sm text-gray-600  ">
    //           {/* {roles.join(" , ") || "--"} */}
    //           Logged in
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">Sessions</div>,
    // }),

    // columnHelper.accessor((row: any) => row.ip, {
    //   id: "user_ip",
    //   cell: (info: any) => {
    //      const row = info.row;

    //     return (
    //       <div className=" hidden md:block leading-10">
    //         <div className=" leading-5 mt-1  text-sm text-gray-600  ">
    //           {/* {roles.join(" , ") || "--"} */}
    //           192.45.34.55
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">IP Address</div>,
    // }),

    // columnHelper.accessor((row: any) => row.country, {
    //   id: "country",
    //   cell: (info: any) => {
    //     // const row = info.row;

    //     return (
    //       <div className=" hidden md:block leading-10">
    //         <div className=" leading-5 mt-1  text-sm text-gray-600  ">
    //           {/* {roles.join(" , ") || "--"} */}
    //           India{" "}
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <div className="hidden md:block">Country</div>,
    // }),

    columnHelper.accessor((row: any) => row.eng_score, {
      id: "eng_score",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className="hidden md:block leading-10">
            {original?.eng_score ? (
              //   <Link
              //     to={`/research/${original.user_id}`} // Navigate to research page
              //     className="font-semibold text-blue-600 text-base underline"
              //   >
              //     {original?.user_research}
              //   </Link>
              <div
                className="font-normal text-gray-900 text-sm leading-5
  "
              >
                {original.eng_score}%
              </div>
            ) : (
              "--"
            )}
          </div>
        );
      },
      header: () => <div className="hidden md:block">Engagement Score</div>,
      enableColumnFilter: true,
    }),

    columnHelper.accessor((row: any) => row.status, {
      id: "status",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;
        const status =
          original.status === "Active" ? "active-status" : "inactive-status";

        return (
          <div className=" hidden md:block leading-10">
            <div
              className={`${status} w-[53px] h-[24px] flex justify-center items-center tracking-wide`}
            >
              {original?.status || "--"}
            </div>
          </div>
        );
      },
      header: () => <div className="hidden md:block">Status</div>,
      enableColumnFilter: true,
    }),

    columnHelper.accessor((row: any) => row.actions, {
      id: "actions",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        const userId = original.user_id;
        return (
          <div className="hidden md:block leading-10">
            <DialogTrigger>
              <div className="pointer-events-auto cursor-pointer transition-opacity duration-300 ease-in-out">
                <Button
                  aria-label="Actions"
                  className="focus:outline-none flex items-center"
                  onPress={() => setShowOuterPopup(true)}
                >
                  <img
                    src="/icons/three-dots-new.svg"
                    alt="dots"
                    className="w-[16px] h-[16px]"
                  />
                </Button>
                <Popover>
                  <div
                    className={`${
                      showConfirmDelete || showOuterPopup === false
                        ? "hidden"
                        : "bg-white focus:outline-none absolute top-[0px] left-[-165px] flex flex-col rounded border border-border text-[#323232] text-[14px] leading-[22.4px] font-normal w-[170px] chat-rename overflow-hidden"
                    } `}
                  >
                    <button
                      className="flex gap-2 text-[#323232] items-center hover:bg-hoverbg p-2 px-3  text-[14px]"
                      onClick={() => {
                        const action_type =
                          original?.status === "Active"
                            ? "Deactivate"
                            : "Activate";
                        handleActions(action_type, userId);
                      }}
                    >
                      {original?.status === "Active"
                        ? "Deactivate"
                        : "Activate"}
                    </button>
                    {/* <button
                      className={`flex gap-2 text-[#323232] focus:outline-none items-center p-2 px-3`}
                      onClick={() => handleActions("Deactivate", userId)}
                    >
                      Restrict 
                    </button> */}
                    <button
                      className="flex gap-2 text-red-500 focus:outline-none hover:bg-hoverbg items-center p-2 px-3"
                      onClick={() => handleActions("Delete", userId)}
                    >
                      Delete
                    </button>
                  </div>
                </Popover>
              </div>
            </DialogTrigger>
          </div>
        );
      },
      header: () => <div className="hidden md:block"></div>,
      enableColumnFilter: true,
    }),

    // columnHelper.accessor((row: any) => row.actions, {
    //   id: "Actions",
    //   cell: (info: any) => {
    //     const row = info.row;
    //     const original = row?.original;

    //     return (
    //       <div className="flex items-center space-x-4">
    //         <FaEye
    //           className="text-gray-500 cursor-pointer"
    //           onClick={() => handleActions("view", original?.user_id)}
    //           title="View"
    //         />

    //         <FaEdit
    //           className="text-gray-500 cursor-pointer"
    //           onClick={() => handleActions("edit", original?.user_id)}
    //           title="Edit"
    //         />

    //         {/* <FaTrashAlt
    //           className="text-red-500 cursor-pointer"
    //           onClick={() => handleActions("delete", original?.user_id)}
    //           title="Delete"
    //         /> */}
    //       </div>
    //     );
    //   },
    //   header: () => <div>Actions</div>,
    // }),
  ];
}

function UserListTable() {
  // const { data: users, isLoading } = useUsers();

  // const [pageIndex, setPageIndex] = useState(0);
  // const [pageSize, setPageSize] = useState(10);

  const location = useLocation();

  const { selectedValue } = useCommonStore();

  const dateRange = getDateRangeFromSelectedValue(selectedValue);

  // const { startDate, endDate } = dateRange!;

  const { pageIndex, pageSize, getPaginationInfo } = usePagination();

  const queryParams = new URLSearchParams(location.search);
  const statusFilter = queryParams.get("status");
  const newFilter = queryParams.get("new_user");

  // const filteredStatus =
  //   statusFilter === "active"
  //     ? "true"
  //     : statusFilter === "inactive"
  //     ? "false"
  //     : "";

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";

  const filteredStatus = newFilter
    ? "new"
    : statusFilter === "active"
    ? "true"
    : statusFilter === "inactive"
    ? "false"
    : "";

  const { data: users, isLoading } = useUsersPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    filteredStatus,
    isAllData
  );

  // const paginationInfo = {
  //   pageIndex,
  //   setPageIndex,
  //   pageSize,
  //   setPageSize,
  //   total: users?.total || 0,
  //   totalPages: users?.total_pages || 1,
  //   hasNext: users?.has_next,
  //   hasPrev: users?.has_prev,
  // };

  const apiData = users?.items || [];
  const columnHelper: any = createColumnHelper();
  const navigate = useNavigate();

  const editUserStatus = usePatchEditUserStatus();

  const deleteUser = useDeleteUser();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { activeUsers, refetchFunctions } = useAdminData();

  const userFetch = refetchFunctions.refetchUsers;

  const filteredUser = apiData.filter((user) => {
    if (statusFilter === "active") return user.status === "Active";
    if (statusFilter === "inactive") return user.status === "Inactive";
    return true;
  });

  const { filteredData } = useMemo(() => {
    return filterDataByDate(filteredUser, selectedValue);
  }, [filteredUser, selectedValue]);

  const paginationInfo = getPaginationInfo(users);

  const [type, setType] = useState<string | null>(null);
  const [id, setId] = useState<string | null>(null);

  const [showOuterPopup, setShowOuterPopup] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const [confirmationPopup, setConfirmationPopup] = useState<{
    isOpen: boolean;
    userId: string | null;
    actionType: UserActionType | "";
  }>({
    isOpen: false,
    userId: null,
    actionType: "",
  });

  const columns = prepareColumns(
    columnHelper,
    handleFetch,
    handleActions,
    showOuterPopup,
    setShowOuterPopup,
    showConfirmDelete,
    setShowConfirmDelete,
    filteredData,
    navigate
  );

  const isBoard = type === "project";
  const isChat = type === "chat";
  const isResearch = type === "research";

  const { isLoading: isBoardLoading, data: boardData } = useProjectByUserId(
    isBoard ? id! : ""
  );
  const { isLoading: isChatLoading, data: chatData } = useChatByUserId(
    isChat ? id! : ""
  );
  const { isLoading: isResearchLoading, data: researchData } =
    useResearchByUserId(isResearch ? id! : "");

  function handleFetch(fetchType: string, fetchId: string) {
    setType(fetchType);
    setId(fetchId);

    // if (fetchType === "chat" && !isChatLoading) {
    //   navigate(`/chats/${fetchId}`);
    // } else if (fetchType === "project" && !isBoardLoading) {
    //   navigate(`/board/${fetchId}`);
    // } else if (fetchType === "research" && !isResearchLoading) {
    //   navigate(`/research/${fetchId}`);
    // }
  }

  //   function handleActions(fetchType: string, fetchId: string) {
  //     if (!isLoading && fetchType === "view") {
  //       navigate(`/user/${fetchId}`);
  //     }

  //     if (!isLoading && fetchType === "edit") {
  //       navigate(`/edit/${fetchId}`);
  //     }
  //     if (!isLoading && fetchType === "delete") {
  //       // console.log("delete");
  //     }
  //   }

  function handleActions(actionType: UserActionType, userId: string) {
    setConfirmationPopup({
      isOpen: true,
      userId,
      actionType,
    });
  }

  const handleConfirm = () => {
    if (confirmationPopup.userId && confirmationPopup.actionType) {
      handleUserStatusUpdate(
        confirmationPopup.userId,
        confirmationPopup.actionType
      );
    }
  };
  const handleUserStatusUpdate = async (
    userId: string,
    action: UserActionType
  ) => {
    // try {
    //   await editUserStatus.mutateAsync({ action, userId });

    //   setConfirmationPopup({ isOpen: false, userId: null, actionType: "" });
    //   setShowOuterPopup(false);

    //   userFetch();
    // } catch (error) {
    //   console.error("Failed to update user status:", error);
    // }

    try {
      if (action === "Delete") {
        await deleteUser.mutateAsync(userId);
      } else {
        await editUserStatus.mutateAsync({ action, userId });
      }

      setConfirmationPopup({ isOpen: false, userId: null, actionType: "" });
      setShowOuterPopup(false);

      userFetch();
    } catch (error) {
      console.error("Failed to update user status:", error);
    }
  };

  useEffect(() => {
    if (!isChatLoading && chatData && type === "chat") {
      navigate(`/chats/${id}`);
    } else if (!isBoardLoading && boardData && type === "project") {
      navigate(`/projects/${id}`);
    } else if (!isResearchLoading && researchData && type === "research") {
      navigate(`/research/${id}`);
    }
  }, [
    boardData,
    chatData,
    id,
    isBoardLoading,
    isChatLoading,
    isResearchLoading,
    navigate,
    researchData,
    type,
  ]);

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <>
      {" "}
      <ReactTanstackTableUi
        data={apiData}
        columns={columns}
        // pagination={apiData?.length > 10}
        noDataMessage="Users"
        tableTitle="Users"
        disableRowHeight={true}
        pagination={true}
        externalPagination={paginationInfo}
        isLoading={isLoading}
        //   additionalButton={updateUserPermission ? "Invite" : ""}
        // btnUrl={`/${orgId}/users/invite`}
      />
      <ConfirmationPopup
        isOpen={confirmationPopup.isOpen}
        actionType={confirmationPopup.actionType}
        onConfirm={() => handleConfirm()}
        onCancel={() =>
          setConfirmationPopup({ isOpen: false, userId: null, actionType: "" })
        }
      />
    </>
  );
}

function NewUsers() {
  return (
    <div className="flex flex-col gap-3">
      <UserListTable />
    </div>
  );
}

export default NewUsers;
